.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.6rem;
}
